import Box from '@mui/material/Box'
import { ReactNode } from 'react'

type Props = {
  children: ReactNode
}

/**
 * Container cố định ở góc dưới bên trái màn hình.
 * Các nút con được xếp thành cột từ dưới lên — thêm item mới vào cuối JSX sẽ tự xếp lên trên.
 */
export const FloatingButtonsContainer = ({ children }: Props) => {
  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: '1rem',
        left: '0.8rem',
        zIndex: 100,
        display: 'flex',
        flexDirection: 'column-reverse',
        alignItems: 'center',
        gap: '0.6rem',
      }}
    >
      {children}
    </Box>
  )
}
